export default __webpack_public_path__ + "03a5c2add4aea8cd464fdcc4249bff32.png";